(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('EventFieldDefinition', EventFieldDefinition);

    EventFieldDefinition.$inject = ['$resource'];

    function EventFieldDefinition ($resource) {
        var resourceUrl = 'api/event-field-definitions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'update': { method: 'PUT' },
            'versions': { method: 'GET', isArray: true, url: 'api/event-field-definitions/:id/versions' }
        });
    }
})();
